import { render, staticRenderFns } from "./TabPenibiliteConfig.vue?vue&type=template&id=1ed9f9a5&"
import script from "./TabPenibiliteConfig.vue?vue&type=script&lang=js&"
export * from "./TabPenibiliteConfig.vue?vue&type=script&lang=js&"
import style0 from "./TabPenibiliteConfig.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports